import { defineComponent as t, resolveComponent as r, openBlock as n, createBlock as s, normalizeProps as c, guardReactiveProps as p, withCtx as l, renderSlot as a, createElementVNode as i } from "vue";
import d from "../CdrIcon.vue.mjs";
import m from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const _ = t({
  name: "Pinterest",
  components: {
    CdrIcon: d
  },
  props: {
    props: {
      type: Object
    }
  }
}), f = /* @__PURE__ */ i("path", {
  role: "presentation",
  d: "M7.677 17.192l1.246-5.156s.126-.623-.196-1.178c0 0-.718-1.771.7-3.273 0 0 1.161-1.298 2.647-.32 0 0 .848.659.506 1.907l-1.009 3.113s-.616 2.367 1.665 2.57c0 0 2.408.32 3.57-2.901 1.161-3.221-.19-5.273-.19-5.273s-1.737-3.012-5.66-2.378c-3.925.634-4.421 4.33-4.421 4.33s-.295 2.278.936 3.938l-.59 1.986S3.879 12.659 4.005 9.25c0 0 .126-5.683 6.013-7.053 0 0 5.331-1.326 8.487 2.904 1.766 2.366 1.64 4.942 1.262 6.853-.379 1.91-1.808 3.133-1.808 3.133s-3.864 4.048-7.226.476l-.715 2.723S9.177 21.236 8.04 22l-.523-.132s-.26-3.287.16-4.676z"
}, null, -1);
function u(e, $, h, C, P, S) {
  const o = r("cdr-icon");
  return n(), s(o, c(p(e.props)), {
    default: l(() => [a(e.$slots, "default"), f]),
    _: 3
  }, 16);
}
const z = /* @__PURE__ */ m(_, [["render", u]]);
export {
  z as default
};
